<div class="header-logo-card">
  <a routerLink="/dashboard" class="logo-link" aria-label="Kiara Connect">
    <img src="Logo.svg" alt="Kiara Connect" class="logo-img" />
  </a>
</div>

<div class="header-main-card">
  <div class="header-controls">
    <div class="user-cluster">
      <button
        type="button"
        class="user-trigger"
        [attr.aria-expanded]="isMenuOpen()"
        aria-haspopup="menu"
        (click)="toggleMenu($event)"
      >
        <div class="user-text-block">
          <span class="user-display-name">
            @if (isLoading()) { Caricamento... } @else { {{ displayName() }} }
          </span>
          <span class="user-email-text">{{ user()?.email }}</span>
        </div>
      </button>
      <button
        type="button"
        class="user-avatar"
        [attr.aria-expanded]="isMenuOpen()"
        aria-haspopup="menu"
        aria-label="Menu utente"
        (click)="toggleMenu($event)"
      >{{ userInitials() }}</button>

      @if (isMenuOpen()) {
        <div class="user-modal" role="menu" aria-label="Menu utente">
          @if (isAdminArea() || isManagerArea()) {
            <button type="button" class="modal-btn modal-btn--profile" role="menuitem" (click)="navigateToProjects()">
              Dashboard utente
            </button>
          } @else {
            @if (isOnProfilePage()) {
              <button type="button" class="modal-btn modal-btn--profile" role="menuitem" (click)="navigateToProjects()">
                Progetti
              </button>
            } @else {
              <button type="button" class="modal-btn modal-btn--profile" role="menuitem" (click)="navigateToProfile()">
                Profilo
              </button>
            }
            @if (isAdmin()) {
              <button type="button" class="modal-btn" role="menuitem" (click)="navigateToAdmin()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                Pannello Admin
              </button>
            }
            @if (isManager()) {
              <button type="button" class="modal-btn" role="menuitem" (click)="navigateToManager()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
                Pannello Manager
              </button>
            }
          }
          <button type="button" class="modal-btn" role="menuitem" (click)="logout()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            Logout
          </button>
        </div>
      }
    </div>
  </div>
</div>

@if (isLogoutModalOpen()) {
  <div class="logout-overlay" (click)="cancelLogout()">
    <div class="logout-card" (click)="$event.stopPropagation()">
      <div class="logout-card__content">
        <svg class="logout-card__icon" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
          <polyline points="16 17 21 12 16 7"/>
          <line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
        <h2 class="logout-card__title">Log out</h2>
        <p class="logout-card__subtitle">Sei sicuro di voler uscire?</p>
      </div>
      <div class="logout-card__actions">
        <button type="button" class="logout-btn logout-btn--cancel" (click)="cancelLogout()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
          Annulla
        </button>
        <button type="button" class="logout-btn logout-btn--confirm" (click)="confirmLogout()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
          Continua
        </button>
      </div>
    </div>
  </div>
}
